import { AppThunk } from '../../../../../store/types';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getAudioById, getNativeLangCodeToTranslate, getNativeLanguage } from '../../../../../store/models/selectors';
import { WordsEffects } from '../../../../../effects/wordsEffects';
import { getAudioWords } from '../../../../../store/words/selectors';

export class WordsTabEvents {

	public static onLoad(): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			// once per page load: returning to the tab reuses the stored list (generate updates it in place)
			if (audioId && !getAudioWords(getState(), audioId)) dispatch(WordsEffects.load(audioId, getNativeLangCodeToTranslate(getState(), audioId)));
		}
	}

	public static onLoadLemmas(words: string[]): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			const langCode = audioId ? getAudioById(getState(), audioId)?.language?.code : undefined;
			if (langCode && words.length) dispatch(WordsEffects.loadLemmas(langCode, words));
		}
	}

	public static onLoadNative(): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			const nativeLangCode = getNativeLanguage(getState())?.code;
			if (audioId && nativeLangCode) dispatch(WordsEffects.loadNative(audioId, nativeLangCode));
		}
	}

	public static onGenerate(): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(WordsEffects.generate(audioId));
		}
	}

}
